/**
 * The plot registry as data: per kind, fits per slot, what a fits count
 * counts, the alternatives a toggle may switch to, the chart-label budgets and
 * registry constants. Generated from packages/slide-schemas/plots (x-plot) and
 * held equal to the schemas by check_parity.py.
 */

import plotRegistryJson from '@digital-twins/slide-schemas/generated/plot-registry.json'

import {
  PlotKind,
  PlotRegistryEntry,
} from '@digital-twins/slide-schemas/generated/plot-types'

// JSON imports widen string unions to `string`; the parity check guarantees
// every entry validates against `PlotRegistryEntry`.
export const PLOT_REGISTRY = plotRegistryJson.kinds as unknown as Record<PlotKind, PlotRegistryEntry>
